import axios from "axios";

export const get = async (assessment:string, strategy?:number) => {
    let url = process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/"+assessment+"/risks";
    if(strategy) {
        url+="/"+strategy;
    }
    let response = await axios.get(url);
    return response.data;
};
